<template>
<div class="plutus-container">
  <img v-lazy="image"/>
  <van-panel title="本月吸金总额" :desc="amount">
    <div slot="footer">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
      >
        <van-cell
          v-for="(item, index) in list"
          :key="index">
          <van-row>
            <van-col span="20">
              <p>{{item.mtime}}</p>
            </van-col>
            <van-col span="4">
              <p>{{item.amount}}</p>
            </van-col>
          </van-row>
        </van-cell>
      </van-list>
    </div>
  </van-panel>
</div>
</template>

<script>
import {
  Tag,
  Row,
  Col,
  Icon,
  Cell,
  List,
  Panel,
  NoticeBar,
  CellGroup
} from "vant";

export default {
  components: {
    [Tag.name]: Tag,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [List.name]: List,
    [Panel.name]: Panel,
    [NoticeBar.name]: NoticeBar,
    [CellGroup.name]: CellGroup
  },
  data() {
    return {
      amount: "-",
      list: [],
      loading: false,
      finished: false,
      pn: 0,
      ps: 5,
      image:"/img/plutus.gif"
    };
  },
  methods: {
    loadPlutus(openid) {
      this.$http
        .get("https://cb.xhare.cn/plutus", {
          params: { openid: openid, pn: this.pn, ps: this.ps }
        })
        .then(
          function(res) {
            if (res.data.code == 0) {
              if (this.pn == 0) {
                this.amount = res.data.amount;
              }
              if (res.data.data.length < this.ps) {
                this.finished = true;
              }
              if (res.data.data.length > 0) {
                res.data.data.forEach(element => {
                  this.list.push({
                    amount: element.amount,
                    mtime: element.mtime
                  });
                });
              }

              this.loading = false;
            }
            this.pn++;
          }.bind(this)
        )
        .catch(
          function() {
            this.redirect();
          }.bind(this)
        );
    },
    redirect() {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx1939c838a577589a&redirect_uri=https://m.xhare.cn/i/%23plutus&response_type=code&scope=snsapi_base&state=ucenter";
    },
    onLoad() {
      let openid = sessionStorage.getItem("openid");
      if (openid) {
        this.loadPlutus(openid);
      } else {
        this.$http
          .get("https://cb.xhare.cn/openid", {
            params: {
              code: (window.location.search
                .substr(1)
                .match(/(^|&)code=([^&]*)(&|$)/i) || [])[2]
            }
          })
          .then(
            function(res) {
              if (res.data.openid == "") {
                this.redirect();
              } else {
                this.loadPlutus(res.data.openid);
                sessionStorage.setItem("openid", res.data.openid);
              }
            }.bind(this)
          )
          .catch(
            function() {
              this.redirect();
            }.bind(this)
          );
      }
    }
  },
  mounted() {
  }
};
</script>

<style lang="less">
.plutus {
  &-container {
    background-color: #FFD700;
    .van-cell__label {
      font-size: 20px;
    }
  }
}
</style>
